import { useState, useEffect } from "react";

import { Message } from "../types/message";
import { subscribeToServiceMessages } from "../api/firebase/firebaseServiceChat";

export const useServiceChatMessages = (threadId: string) => {
  const [messages, setMessages] = useState<Message[]>([]);

  useEffect(() => {
    if (!threadId) return;

    const unsubscribe = subscribeToServiceMessages(threadId, (msgs) => {
      setMessages(msgs);
    });

    return () => unsubscribe();
  }, [threadId]);

  return {
    messages,
  };
};
